import {fromJS} from 'immutable';

const schoolLinks = fromJS([
  {
    name: 'Dashboard',
    route: '/dashboard'
  },
  {
    name: 'Manage Staff',
    route: '/manage-staff'
  },
  {
    name: 'School Accounts',
    route: '/school-accounts'
  },
  {
    name: 'Usage Reports',
    route: '/usage-reports'
  }
]);

export default schoolLinks;
